module.exports = __webpack_public_path__ + "img/result-detail-communication-inleft01.cc9a4846.svg";